/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { FC, useEffect, useMemo, useState } from 'react'
import { FieldProps } from 'formik'
import debounce from 'lodash.debounce'
import { SelectProps as KitSelectProps } from '@mtsbank/ui-kit'
import { InputHelperText, InputErrorMessage } from '@shared/ui/atoms'

export interface SelectFieldProps extends Partial<FieldProps>, Partial<KitSelectProps> {
  hint?: string
}

export const OldSelectField: FC<SelectFieldProps> = ({
  field,
  // @ts-ignore
  form: { touched, errors },
  hint,
}) => {
  // @ts-ignore
  const touchedItem = touched[field.name]
  // @ts-ignore
  const errorItem = errors[field.name]
  const [hasError, setHasError] = useState<boolean>(touchedItem && Boolean(errorItem))
  const setHasErrorDebounced = useMemo(
    () =>
      debounce((hasError: boolean) => setHasError(hasError), 100, {
        leading: false,
        trailing: true,
      }),
    [setHasError]
  )

  useEffect(() => {
    setHasErrorDebounced(touchedItem && Boolean(errorItem))
  }, [touchedItem, errorItem, setHasErrorDebounced])
  // todo доработать юайкит чтобы можно было искать по опциям

  return (
    <div>
      {/* @ts-ignore */}
      {/* <OldSelect
        {...field}
        {...rest}
        size={size}
        hasError={touched[field?.name] && !!errors[field?.name]}
        onChange={handleChange}
        onBlur={() => {}} // todo в input value сохраняется значение label, в field.value - value, поэтому происходит ререндер на onBlur Нужно пофиксить
      /> */}
      {hint && !hasError && <InputHelperText>{hint}</InputHelperText>}
      {hasError && <InputErrorMessage name={field?.name} />}
    </div>
  )
}
